import React, { useState, useEffect, useReducer } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button, Collapse } from 'react-bootstrap';
import { Link, useLocation } from "react-router-dom";
import { useFilteredMenus } from './adminMenu';
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useTranslation } from 'react-i18next';
import webservice from '../../../services/webservice';
// import { userdataflag } from "./store";
import { useDispatch } from 'react-redux';
import { AesDecrypt } from '../../../services/crypto';
import { navtoggle } from '../../../store/actions/AuthActions';
import medhorizone_logo from "../../../images/medhorizone_logo.png";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const SideBar = React.memo(({ onClick, onClick3 }) => {
  const { t } = useTranslation();
  const [state, setState] = useReducer(reducer, initialState);
  const [userDataFlag, setUserDataFlag] = useState('');
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleMenu = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handlecheckclick = () => {
    // Dispatch action to fetch data
    // dispatch(userdataflag(localStorage.id))
    //   .then((res) => {
    //     if (res.payload.response === 'S') {
    //       const data1 = AesDecrypt(res.payload.data);
    //       if (data1.length !== 0) {
    //         setUserDataFlag('data1');
    //       }
    //     }
    //   })
    //   .catch((error) => {
    //     console.error('Error fetching profile:', error);
    //     // Handle error
    //   });
  };

  // useEffect(() => {
  //   // Initial fetch on component mount
  //   const _id = localStorage.id;
  //   dispatch(userdataflag(_id))
  //     .then((res) => {
  //       if (res.payload.response) {
  //         const data1 = AesDecrypt(res.payload.data);
  //         if (data1.length !== 0) {
  //           setUserDataFlag(data1);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching profile:', error);
  //       // Handle error
  //     });
  // }, [dispatch]);

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }

  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }

  };


  const handleMenuClickresaluation = () => {
    if (window.innerWidth < 780) {
      dispatch(navtoggle())
    }
  }

  const handleMenuClick = () => {
    setShowModal(true);
  };

  // For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const usertype = localStorage.getItem('usertype');
  const dynamicMenuList = useFilteredMenus();

  const location = useLocation();
  const fullPath = location.pathname;
  let path = fullPath.split("/").pop();

  const renderList = React.useMemo(() => {
    return dynamicMenuList;
  }, [dynamicMenuList]);

  useEffect(() => {
    const list = renderList;
    const normalizePath = (p) => (p && p.startsWith('/') ? p : `/${p}`);

    list.forEach((data) => {
      // Check if current path matches the parent 'to' or any of its children
      const isParentActive =
        (fullPath === normalizePath(data.to) || fullPath.startsWith(`${normalizePath(data.to)}/`)) ||
        data.content?.some(item =>
          fullPath === normalizePath(item.to) || fullPath.startsWith(`${normalizePath(item.to)}/`) ||
          item.content?.some(ele => fullPath === normalizePath(ele.to) || fullPath.startsWith(`${normalizePath(ele.to)}/`))
        );

      if (isParentActive) {
        setState({ active: data.title });

        // Also find and set activeSubmenu if applicable
        data.content?.forEach((item) => {
          if (fullPath === normalizePath(item.to) || fullPath.startsWith(`${normalizePath(item.to)}/`)) {
            // Submenu found
          }
          item.content?.forEach(ele => {
            if (fullPath === normalizePath(ele.to) || fullPath.startsWith(`${normalizePath(ele.to)}/`)) {
              setState({ activeSubmenu: item.title });
            }
          });
        });
      }
    });
  }, [fullPath, usertype]);


  return (
    <div className="deznav" style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      <style>{`
        .deznav {
          background-color: #ffffff !important;
        }
        [data-theme-version="dark"] .deznav {
          background-color: #ffffff !important;
        }
        .deznav .deznav-scroll {
          padding-bottom: 55px !important;
        }
        .deznav .metismenu > li {
          margin-bottom: 6px !important;
          margin-top: 6px !important;
        }
        .deznav .metismenu > li > a {
          color: #000 !important;
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
        .deznav .metismenu li.mm-active > a,
        .deznav .metismenu li.mm-active > a:hover,
        .deznav .metismenu li.mm-active > a:focus {
          background-color: #e6f2ff !important;
          color: #007bff !important;
        }
        .deznav .sidebar-footer {
          background-color: #f9fcfcff !important;
          position: absolute !important;
          bottom: 0 !important;
          width: 100% !important;
          z-index: 10 !important;
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 20px 0 !important;
          gap: 12px !important;
        }
        .deznav .sidebar-footer .footer-logo-custom {
          height: 24px !important;
          width: 24px !important;
          object-fit: contain !important;
          max-width: none !important;
          margin: 0 !important;
          display: block !important;
          flex-shrink: 0 !important;
          visibility: visible !important;
          opacity: 1 !important;
        }
        .deznav .sidebar-footer .update-version {
          font-size: 16px !important;
          line-height: 24px !important;
          margin: 0 !important;
          font-weight: bold !important;
          color: #000 !important;
        }
        .deznav .custom-submenu-arrow {
          font-size: 11px !important;
          opacity: 0.8 !important;
        }
      `}</style>
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {renderList.map((data, index) => (
            <li
              className={`has-menu ${state.active === data.title ? 'mm-active' : ''} ${data.to && data.to.replace(/^\//, '') === path ? 'mm-active' : ''}`}
              key={index}
              onClick={() => {
                handlecheckclick();
                if (onClick) onClick();
              }}
            >

              {data.content && data.content.length > 0 ? (
                <>
                  <Link to="#" className="ai-icon" onClick={() => handleMenuActive(data.title)} style={{ 
                    color: state.active === data.title ? '#007bff' : '#000',
                    backgroundColor: state.active === data.title ? '#e6f2ff' : 'transparent',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <div className="faicons" style={{ color: state.active === data.title ? '#007bff' : '#000' }}>{data.iconStyle}</div>
                    <span className="nav-text" style={{ color: state.active === data.title ? '#007bff' : '#000', flex: 1, display: 'flex', alignItems: 'center' }}>
                      {t(data.title)}
                      {data.update && (
                        <span className="badge badge-xs style-1 badge-danger ms-2">
                          {data.update}
                        </span>
                      )}
                    </span>
                    <i className={`fas fa-caret-${state.active === data.title ? 'down' : 'right'} custom-submenu-arrow`} style={{ color: state.active === data.title ? '#007bff' : '#000', marginLeft: 'auto' }}></i>
                  </Link>
                  <Collapse in={state.active === data.title}>
                    <ul className={`mm-collapse ${state.active === data.title ? "mm-show" : ""}`} style={{ backgroundColor: '#fff', padding: '5px 15px', borderRadius: '8px', minWidth: '260px', width: '100%' }}>
                      {data.content.map((subData, subIndex) => (
                        <li
                          key={subIndex}
                          className={`${state.activeSubmenu === subData.title ? "mm-active" : ""} ${subData.to && subData.to.replace(/^\//, '') === path ? 'mm-active' : ''}`}
                          style={{ backgroundColor: '#fff' }}
                        >
                          {subData.content && subData.content.length > 0 ? (
                            <>
                              <Link to={subData.to} className={subData.hasMenu ? 'has-arrow' : ''} onClick={() => handleSubmenuActive(subData.title)} style={{ 
                                color: state.activeSubmenu === subData.title ? '#007bff' : '#000', 
                                backgroundColor: state.activeSubmenu === subData.title ? '#e6f2ff' : '#fff', 
                                borderRadius: '8px', padding: '10px 15px' 
                              }}>
                                {t(subData.title)}
                              </Link>
                              <Collapse in={state.activeSubmenu === subData.title}>
                                <ul className="mm-collapse mm-show" style={{ backgroundColor: '#fff', padding: '5px 10px' }}>
                                  {subData.content.map((subSubData, subSubIndex) => {
                                    const isSubSubActive = subSubData.to && subSubData.to.replace(/^\//, '') === path;
                                    return (
                                      <li key={subSubIndex} style={{ backgroundColor: '#fff' }}>
                                        <Link className={`${isSubSubActive ? "mm-active" : ""}`} to={subSubData.to} style={{ 
                                          color: isSubSubActive ? '#007bff' : '#000', 
                                          backgroundColor: isSubSubActive ? '#e6f2ff' : '#fff', 
                                          borderRadius: '8px', padding: '10px 15px' 
                                        }}>
                                          {subSubData.title}
                                        </Link>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </Collapse>
                            </>
                          ) : (
                            <Link to={subData.to} className={`${subData.to && subData.to.replace(/^\//, '') === path ? 'mm-active' : ''}`} style={{ 
                              color: (subData.to && subData.to.replace(/^\//, '') === path) ? '#007bff' : '#000', 
                              backgroundColor: (subData.to && subData.to.replace(/^\//, '') === path) ? '#e6f2ff' : '#fff', 
                              borderRadius: '8px', padding: '10px 15px' 
                            }}>
                              <div className="faicons" style={{ color: (subData.to && subData.to.replace(/^\//, '') === path) ? '#007bff' : '#000' }}>{subData.iconStyle}</div>
                              <span className="nav-text" style={{ color: (subData.to && subData.to.replace(/^\//, '') === path) ? '#007bff' : '#000' }}>{t(subData.title)}</span>
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </Collapse>
                </>
              ) : (
                <Link to={data.to} className="ai-icon" style={{
                  color: (data.to && data.to.replace(/^\//, '') === path) ? '#007bff' : '#000',
                  backgroundColor: (data.to && data.to.replace(/^\//, '') === path) ? '#e6f2ff' : 'transparent',
                  borderRadius: '10px'
                }}>
                  <div className="faicons" style={{ color: (data.to && data.to.replace(/^\//, '') === path) ? '#007bff' : '#000' }}>{data.iconStyle}</div>
                  <span className="nav-text" style={{ color: (data.to && data.to.replace(/^\//, '') === path) ? '#007bff' : '#000' }}>{t(data.title)}</span>
                </Link>
              )}
            </li>
          ))
          }
        </ul>
      </div>

      <div className="sidebar-footer">
        <img className="footer-logo-custom" src={medhorizone_logo} alt="logo" />
        <div className="update-version">Version : 1.2.4</div>
        {/* here eg : version = 1.2.3
             1 = major - fix or change the high level functionality and modify the the fn 
             2 = minor -  added the new feature and don't touch old functionality
             3 = patch - small fix and debug i
              */}
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Sanjeevani BOT:")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginLeft: '5%' }}>
            {t("You need to complete your profile details to access this menu")}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Link to={'/Demography'}>
            <div>
              <Button style={{ width: '100%' }} onClick={() => setShowModal(false)}>Click Here</Button>
            </div>
          </Link>
        </Modal.Footer>
      </Modal>
    </div>
  );
});

export default SideBar;
